import React from "react";
import { useTranslation } from "react-i18next";
import { jsonToCSV } from "react-papaparse";
import { UserDetail } from "../../../../data/interfaces";

// -----------------------------------------------------------------
// I n t e r f a c e s
// -----------------------------------------------------------------
interface Props {
  userData?: UserDetail | null;
}

const ExportPersonalData = ({ userData, ...props }: Props) => {
  // -----------------------------------------------------------------
  // L o c a l   v a r s
  // -----------------------------------------------------------------
  // Access to i18n instance that you may use to translate your content.
  const { t } = useTranslation();

  // -----------------------------------------------------------------
  // W o r k i n g   m e t h o d s
  // -----------------------------------------------------------------
  /**
   * Generate and download account data
   * @function
   * @async
   */
  const downloadAccountData = async () => {
    const dataToDownload: any = {
      email: userData?.email,
      firstname: userData?.firstname,
      lastname: userData?.lastname,
      phone_number: userData?.phone_number,
      privacy_policy_consent: userData?.privacy_policy_consent,
      fiscal_code: userData?.cfu_info?.fiscal_code,
      membership_group: userData?.cfu_info?.membership_group,
      membership_group_location: userData?.cfu_info?.membership_group_location,
      subscription_number: userData?.cfu_info?.subscription_number,
      company_city: userData?.company.address.city,
      company_country: userData?.company.address.country,
      company_state: userData?.company.address.state,
      company_street: userData?.company.address.street,
      company_zip_code: userData?.company.address.zip_code,
      company_core_business: userData?.company.core_business,
      company_email: userData?.company.email,
      company_name: userData?.company.name,
      company_phone_number: userData?.company.phone_number,
      company_type: userData?.company.type,
      company_user_role: userData?.company.user_role,
    };

    const csv = jsonToCSV([dataToDownload], {
      delimiter: ";",
      newline: ";;",
    });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(new Blob([JSON.stringify(csv)], { type: "text/csv" }));
    link.download = `${userData?.firstname}-${userData?.lastname}`.toLowerCase() + ".csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // -----------------------------------------------------------------
  // T e m p l a t e
  // -----------------------------------------------------------------
  return (
    <>
      <small className={"link"} onClick={downloadAccountData}>
        {t("pages.profile.export_my_data")}
      </small>
    </>
  );
};
export default ExportPersonalData;
